import React, { useEffect, useState } from "react";
// import PropTypes from 'prop-types';
import { Text, Box } from "grommet";
import { useTranslation } from "react-i18next";
import { useFetchHotel } from "../dashboard/redux/fetchHotel";
import { getBookingStatusLabel } from "../../common/bookingStatus";
import CommsFailedBadge from "./CommsFailedBadge";

export default function BookingStatus(props) {
  const { status, onClick, commsFailed } = props;
  const { hotel } = useFetchHotel();
  const { t } = useTranslation();
  const isMessaging = hotel?.serviceType === "messaging";

  const [color, setColor] = useState("dark-6");
  const [bgColor, setBgColor] = useState();

  useEffect(() => {
    setBgColor(undefined);
    if (status)
      switch (status.slug) {
        case "keysent":
          setColor("status-ok");
          break;
        case "keyused":
          setColor("white");
          setBgColor("neutral-1");
          break;
        case "checkedout":
          setColor("neutral-4");
          break;
        case "onlinecheckin":
          setColor("status-warning");
          break;
        case "inperson":
          setColor("brand");
          break;
        case "cancelled":
          setColor("status-error");
          break;
        case "checkedin":
          setColor(isMessaging ? "status-ok" : "neutral-2");
          break;
        case "new":
        default:
          setColor("dark-1");
      }
  }, [status, isMessaging]);

  const showCommsFailedBadge = !!commsFailed;

  return (
    <Box
      style={{
        width: "fit-content",
        margin: "auto",
      }}
      direction="row"
      pad={{ horizontal: "small" }}
      align="center"
      round="small"
      border={{ color: bgColor || color, size: "small" }}
      background={bgColor}
      onClick={onClick}
    >
      <Text size="xsmall" color={color}>
        {getBookingStatusLabel(status, hotel?.serviceType, t)}
      </Text>
      {showCommsFailedBadge && <CommsFailedBadge />}
    </Box>
  );
}

BookingStatus.propTypes = {};
BookingStatus.defaultProps = {};
